/**
 * Búsqueda de texto de los listados del portal.
 *
 * Todos los buscadores del portal comparan igual: sin mayúsculas, sin tildes y
 * **sin separadores**, de modo que `FA01-002347` se encuentra escribiendo
 * `fa01002347` o simplemente `002347`. Antes cada pantalla lo resolvía a su
 * manera (o no lo tenía).
 */

/** Texto en minúsculas y sin tildes. */
export function normalizarTexto(valor: unknown): string {
  return String(valor ?? '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

/**
 * ¿Alguno de los campos contiene el término buscado?
 *
 * Los campos se unen con espacios (para poder buscar «diesel B5» aunque uno sea
 * el producto y otro la placa) y se comparan también sin guiones, puntos ni
 * barras.
 */
export function coincideBusqueda(campos: unknown[], busqueda: string): boolean {
  const termino = normalizarTexto(busqueda).trim();

  if (termino === '') return true;

  const texto = normalizarTexto(campos.join(' '));

  if (texto.includes(termino)) return true;

  const compacto = termino.replace(/[^a-z0-9]/g, '');

  return compacto !== '' && texto.replace(/[^a-z0-9]/g, '').includes(compacto);
}
